export const actionDeclarer = new Proxy( {}, {
	get( target, name ) {
		const x = {
			[ name ]: ( dispatch, signal ) => payload => {
				if ( !signal?.aborted ) {
					dispatch( {
						type: x[ name ],
						payload
					} );
				}
			}
		};

		return x[ name ];
	}
} );
